const env = process.env.REACT_APP_ENV;

const merchant_theme = {
  dev: {},
  test: {
    113484: {
      "--primary-theme-color": "#000",
      "--primary-text-color": "#000",
      "--secondary-text-color": "#2189ff",
    },
  },
  mig: {
    119815: {
      "--primary-theme-color": "#000",
      "--primary-text-color": "#000",
      "--secondary-text-color": "#2189ff",
    },
  },
  uat: {
    106598: {
      "--primary-theme-color": "#000",
      "--primary-text-color": "#000",
      "--secondary-text-color": "#2189ff",
    },
  },
  prod: {
    268955: {
      "--primary-theme-color": "#000",
      "--primary-text-color": "#000",
      "--secondary-text-color": "#2189ff",
    },
  },
};

export const getTheme = (merchantId) => {
  const merchantData = merchant_theme[env] && merchant_theme[env][merchantId]
    ? merchant_theme[env][merchantId]
    : {
        "--primary-theme-color": "#3fb449",
        "--primary-text-color": "#3fb449",
        "--secondary-text-color": "#3fb449",
      };
  return merchantData;
};

export const ChangeTheme = (merchantId) => {
  const obj = getTheme(merchantId);
  const root = document.documentElement;

  if (obj && obj["--primary-text-color"]) {
    root.style.setProperty(
      "--primary-theme-color",
      obj["--primary-theme-color"]
    );
    root.style.setProperty("--primary-text-color", obj["--primary-text-color"]);
    root.style.setProperty(
      "--secondary-text-color",
      obj["--secondary-text-color"]
    );
  }
};
